import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/slide-button/slide-button.js';
      import {ObcSlideButtonSlideEvent} from '@oicl/openbridge-webcomponents/dist/components/slide-button/slide-button.js';

      export interface Props {
     disabled?: boolean;
     hasLeadingIcon?: boolean;
     hugContent?: boolean;
     autoDisable?: boolean
   }

      
  
      export type {ObcSlideButtonSlideEvent} from '@oicl/openbridge-webcomponents/dist/components/slide-button/slide-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSlideButton',
  props: {
    disabled: { type: Boolean },
    hasLeadingIcon: { type: Boolean },
    hugContent: { type: Boolean },
    autoDisable: { type: Boolean }
  },
  emits: ["slide"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onSlide: (event: ObcSlideButtonSlideEvent) => emit('slide', event as ObcSlideButtonSlideEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-slide-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})